import ineco from "./icons/ineco.png";
import binance from "./icons/binance.png";
import userIcon from "./icons/user.png";
import cashIcon from "./icons/cash.png";
import idbankIcon from "./icons/idbank.png";
import bybitIcon from "./icons/bybit.png";
import evocaIcon from "./icons/evoca.png";
import ameriaIcon from "./icons/ameria.png";
import cancel from "./icons/cancel.png";
import acba from "./icons/acba.png";
import converse from "./icons/converse.jpg";
import ardshin from "./icons/ardshin.png";
import ararat from "./icons/araratbank.png";

export const icons = {
    INECO: ineco,
    BINANCE: binance,
    user: userIcon,
    "INECO HRACH": ineco,
    "INECO MERI": ineco,
    "INECO PRIVATE (HRACH)": ineco,
    "INECO HRACH PE":ineco,
    "INECO NORA":ineco,
    "CASH FOR INDIAN": cashIcon,
    CASH: cashIcon,
    "CASH FAHAD": cashIcon,
    "IDBANK MERI": idbankIcon,
    BYBIT: bybitIcon,
    "EVOCA HRACH": evocaIcon,
    "AMERIA MERI": ameriaIcon,
    CANCEL: cancel,
    "CONVERSE HRACH":converse,
    "ACBA HRACH":acba,
    "ARDSHIN MERI":ardshin,
    "ARARATBANK HRACH":ararat
};
